import { request } from '../../helpers/api/request';
import { UpdateFaqContract, UpdateFaqModel } from '../../types/Endpoints/faq/FaqContracts';

export const updateFaq = async ({ id, ...requestData }: UpdateFaqModel & { id: number }) => {
    const { data } = await request<UpdateFaqContract>({
        url: `admin/faq/${id}`,
        method: 'PATCH',
        data: requestData,
    });

    return data;
};
